export default (roundId, playerId) => (playerId ? `${playerId}@${roundId}` : null)
